import { Injectable } from '@angular/core';
import { SeaCarrierLookupModel } from 'app/generated/backend/sea/api/sea-carrier-lookup-model';
import { CachedEntityService } from 'app/_templates/CachedEntityService';
import { CoreCacheService } from '../cache/CoreCacheService';
import { SeaLclCarrierLookupHandlerService } from 'app/generated/backend/sea/service/sea-lcl-carrier-lookup-handler';

@Injectable()
export class CoreSeaLclCarrierLookupService extends CachedEntityService<SeaCarrierLookupModel> {
	constructor(
		service: SeaLclCarrierLookupHandlerService,
		cacheService: CoreCacheService
	) {
		super(service, cacheService.getSeaLclCarriers());
	}
	transformItem(item: SeaCarrierLookupModel): SeaCarrierLookupModel {
		if (item) {
			item.match = '';
			if (item.name) {
				item.match += item.name.toLowerCase();
			}
			if (item.name) {
				item.match += ' ' + item.name.toLowerCase();
			}
		}
		return item;
	}
}
